﻿import { IMaterial } from "../../interfaces";

export const Validate = {
    materialLocationDetails: (material: IMaterial) => {

        //all material must have an arrival date
        if (!material.arrivalDate)
            return true;

        if (material.site && material.site.value?.startsWith("External")) {
            return false;
        } else {

            if (!material.warehouse) return true;
            if (!material.rack) return true;
            if (!material.row) return true;
            if (!material.pallet) return true;

            return false;
        }

    }
};
